(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motion.matches || !('IntersectionObserver' in window) ||
      document.body.classList.contains('template-product') ||
      document.body.classList.contains('template-collection') ||
      document.body.classList.contains('template-list-collections')) return;
  const selector = '.main-content > .shopify-section, .main-content > .mp-native-page';
  const seen = new WeakSet();
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const element = entry.target;
      observer.unobserve(element);
      element.classList.add('mp-scroll-reveal--visible');
      window.setTimeout(() => element.classList.remove('mp-scroll-reveal', 'mp-scroll-reveal--visible'), 800);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
  function targets(root) {
    const result = [];
    const wrappers = root.matches?.(selector) ? [root] : [...root.querySelectorAll(selector)];
    wrappers.forEach((wrapper) => {
      if (wrapper.matches('.mp-native-page')) {
        result.push(...wrapper.querySelectorAll('.mp-about > .mp-hero, .mp-about .mp-badges > .mp-card, .mp-about .mp-why > .mp-pane, .mp-about .mp-cta, .mp-about .mp-faq > details, .mp-policy > header, .mp-policy .mp-card, .mp-faq > header, .mp-faq .mp-item, .mp-faq .mp-note'));
      } else if (wrapper.querySelector('.product-list')) {
        result.push(...wrapper.querySelectorAll('.product-list > .card'));
      } else if (wrapper.querySelector('.article-template .rte')) {
        result.push(...wrapper.querySelectorAll('.article-template .rte > :is(h2, h3, p, ul, ol, blockquote, figure)'));
      } else {
        result.push(wrapper);
      }
    });
    return result;
  }
  function prepare(root = document) {
    const viewport = window.innerHeight;
    targets(root).forEach((element) => {
      if (seen.has(element)) return;
      seen.add(element);
      const rect = element.getBoundingClientRect();
      if (rect.height < 24 || rect.width < 24 || rect.top < viewport * .85) return;
      element.classList.add('mp-scroll-reveal');
      observer.observe(element);
    });
    document.documentElement.classList.add('mp-scroll-ready');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare(), { once: true });
  else prepare();
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
  motion.addEventListener?.('change', (event) => {
    if (!event.matches) return;
    observer.disconnect();
    document.querySelectorAll('.mp-scroll-reveal').forEach((element) => element.classList.remove('mp-scroll-reveal', 'mp-scroll-reveal--visible'));
  });
})();
